import {InlineCountdownLazy} from 'app/modules/inlineCountdown/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineInlineCountdown(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-inline-countdown')) {
        return;
    }

    customElements.define(
        'gem-inline-countdown',
        class extends WebComponentLoader {
            reactLazyComponent = InlineCountdownLazy;
            hasConfig = false;
        },
    );
}
